import * as R from 'ramda';
import {hasValueArray} from 'Utils';

export const findFstMenu = (fstMenuCode, menuList) => {
  return R.find(R.propEq('code', fstMenuCode))(menuList);
};

export const findSecMenu = (secMenuCode, menuList = []) => {
  if (hasValueArray(menuList)) {
    for (let i = 0, len = menuList.length; i < len; i++) {
      const {path, children} = menuList[i];
      if (path.replace('/', '') === secMenuCode) {
        return {
          ...menuList[i],
        };
      }
      const menu = findSecMenu(secMenuCode, children);
      if (Object.keys(menu).length > 0) {
        return menu;
      }
    }
  }
  return {};
};

// 提取pathname正则，例/a/b/c?r=1
const RE = /^\/(\w+)(\/[/\w]+)?(\?.+)?$/;

export const findMoreMenu = (moreMenuPath, menuList = []) => {
  if (!moreMenuPath) {
    return {};
  }

  if (!hasValueArray(menuList)) {
    return {};
  }

  const [, code, nextPath] = RE.exec(moreMenuPath);
  const firstMenu = findFstMenu(code, menuList);

  // 找不到一级路由
  if (!firstMenu) {
    const noCodeMenus = menuList.filter(menu => !menu.code);
    // 处理code为null，伪路由的情况
    if (noCodeMenus.length > 0) {
      const nextMenus = noCodeMenus.reduce(
        (menus, now) => [...menus, ...(now.children || [])],
        [],
      );
      return findMoreMenu(moreMenuPath, nextMenus);
    }
    return {};
  }

  // 子级路由存在 && 当前menu存在children
  if (nextPath && firstMenu.children) {
    return findMoreMenu(nextPath, firstMenu.children);
  }

  // 成功返回
  if (!nextPath && !firstMenu.children) {
    return {...firstMenu};
  }

  return {};
};
